/**
 * @file CGV.tsx
 * @summary Page légale
 *
 * Page de mentions légales / RGPD / CGU / cookies. Conformité Privacy by design — cookies essentiels uniquement.
 *
 * @see docs/07-CODEBASE.md — conventions de code
 * @see docs/02-FRONTEND.md — design system (tokens HSL, typographie)
 */
import LegalPage from "@/components/LegalPage";

export default function CGV() {
  return (
    <LegalPage
      title="Conditions générales de vente"
      subtitle="Modalités de vente des prestations CrossFit Chistera"
      canonicalPath="/legal/cgv"
      seoTitle="CGV — Conditions générales de vente | CrossFit Chistera"
      seoDescription="Conditions générales de vente CrossFit Chistera : abonnements, cartes, drop-in, séance d'essai, modalités via ResaWOD et conditions de résiliation."
      remember={[
        "Site vitrine : ventes principalement via ResaWOD",
        "2 séances d'essai gratuites",
        "Drop-in : 15 € HT",
        "Sans engagement, préavis 2 mois",
      ]}
    >
      <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-r-lg mb-8">
        <p className="text-sm text-blue-800"><strong>Info :</strong> Le site est un site vitrine. Les achats, souscriptions, réservations confirmées et paiements sont réalisés principalement via l'outil ResaWOD et/ou directement auprès de la box.</p>
      </div>

      <h2>1. Objet</h2>
      <p>Les présentes CGV définissent les modalités de vente des prestations proposées par CrossFit Chistera : abonnements, cartes/carnets, drop-in, séances d'essai, produits ou options accessoires.</p>

      <h2>2. Définitions</h2>
      <ul>
        <li><strong>Adhérent :</strong> personne disposant d'un abonnement ou accès actif à la box</li>
        <li><strong>Client :</strong> toute personne souscrivant une prestation</li>
        <li><strong>Séance d'essai :</strong> séance de découverte, gratuite ou payante selon l'offre en cours</li>
        <li><strong>Drop-in :</strong> séance à l'unité pour un pratiquant de passage, sous réserve de validation</li>
        <li><strong>Plateforme :</strong> l'outil de gestion utilisé par la box (ResaWOD)</li>
      </ul>

      <h2>3. Informations précontractuelles</h2>
      <p>Avant toute souscription, le client est invité à prendre connaissance des informations essentielles communiquées sur place, via la plateforme et/ou par email. Les informations affichées sur le site sont susceptibles d'évoluer et n'ont pas valeur contractuelle.</p>

      <h2>4. Souscription, paiement, reçus</h2>
      <p>La souscription et le paiement sont réalisés via la plateforme ou directement auprès de la box. Les reçus et historiques sont gérés via la plateforme et/ou la box.</p>

      <h2>5. Réservation, annulation, absences</h2>
      <p>Les règles de réservation et d'annulation sont communiquées dans la plateforme et/ou par les coachs. L'absence ou l'annulation tardive peut entraîner la perte de la séance.</p>

      <h2>5 bis. Planning et créneaux</h2>
      <p>Le planning des cours est donné à titre indicatif. Les créneaux sont fixes, mais certains cours (notamment Hybrid Training) peuvent évoluer selon les périodes. Les coachs communiquent tout changement suffisamment en avance. Il n'y a pas de cours pendant les jours fériés.</p>
      <p>L'inscription à un créneau horaire, hors premiers cours d'essai, s'effectue via l'application Resawod et sous réserve de places disponibles.</p>

      <h2>6. Sécurité, aptitude, encadrement</h2>
      <p>La pratique comporte des risques. Le client déclare être apte à la pratique et s'engage à respecter les consignes, adapter ses charges, signaler toute situation impactant la sécurité. Les coachs peuvent refuser l'accès ou imposer une adaptation.</p>

      <h2>7. Responsabilité</h2>
      <p>CrossFit Chistera ne saurait être tenu responsable des blessures résultant du non-respect des consignes ou des pertes/vols d'effets personnels, dans les limites autorisées par la loi.</p>

      <h2>8. Assurance</h2>
      <p>La box est couverte au titre de sa responsabilité civile professionnelle. Le client est invité à vérifier qu'il dispose d'une assurance personnelle adaptée.</p>

      <h2>9. Données personnelles</h2>
      <p>Le traitement des données est détaillé dans la <a href="/legal/rgpd">Politique RGPD</a>.</p>

      <h2>10. Médiation et litiges</h2>
      <p>En cas de litige, contactez la box en priorité. Le recours à un médiateur de la consommation peut être possible ; coordonnées sur demande à <a href="mailto:contact@crossfitchistera.com">contact@crossfitchistera.com</a>.</p>

      <p>Voir aussi : <a href="/legal/mentions">Mentions légales</a> · <a href="/legal/cgu">CGU</a> · <a href="/legal/rgpd">Politique RGPD</a> · <a href="/lexique">Lexique</a></p>
    </LegalPage>
  );
}
